var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-20"},[_c('app-table',{ref:"app_table_ref",attrs:{"table-key":_vm.table_key,"table-props":{ 'max-height': '450px'},"is-current-page":false,"page-size":2000,"table-list-data":_vm.formItem.assignSelection[_vm.advertiserId]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }